var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectedMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 120,
    viewBox: "0 0 60 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_4332",
    x: 0,
    y: 0,
    width: 60,
    height: 120,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14401",
    "data-name": "Group 14401"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Rectangle_4332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4332-2",
    "data-name": "Rectangle 4332",
    d: "M10,0H50A10,10,0,0,1,60,10V83a30,30,0,0,1-30,30h0A30,30,0,0,1,0,83V10A10,10,0,0,1,10,0Z",
    fill: "#141414"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3",
    "data-name": "Polygon 3",
    d: "M9,0l9,10H0Z",
    transform: "translate(39 120) rotate(180)",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedMarker);
export default __webpack_public_path__ + "static/media/selectedMarker.575699e3cf2cfffdf3eb9a041db7c876.svg";
export { ForwardRef as ReactComponent };